import { css } from 'linaria';

export const AdLabelIconWrapperStyles = css`
  display: flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: rgba(153, 153, 153, 0.7);
  color: var(--text-primary-invert, #fff);
  cursor: pointer;
`;
